export const VIEWING_FORM_SLOT_DROPDOWN_FLOATING_CONFIG = {
  maxWidthByRef: false,
}
